export enum BodyClass {
	simProSessionSelection,
	SIMStation_Tablet,
	SIMStation_Recording,
	SIMStation_OSPE,
	SIMStation_Intro,
	SIMStation_Player,
	SIMStation_Player_black,
	SIMStation_Students,
	sst_joinComments,
	sst_loginScreen,
	sst_tabletDashboard,
	sst_remoteDisplay,
	SIMStation_WebManager,
	logoNotInverted,
	logoInverted,
	hasSidebar,
	hideNav,
}
